import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { Button, Grid } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { EditNote } from "@mui/icons-material";
import moment, { Moment } from "moment";
import { UnloadCollectionInfo } from "../../redux/collection/state";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { OpenSnackBarWithResultFail, OpenSnackBarWithResultSuccess } from "../../redux/common/snackBar/thunk";
import FormDialog from "../common/FormDialog";
import { axiosGet, axiosPutWithJson } from "../../util/axios";
import { ChangeUnloadDataListThunk, InitSelectedUnloadCollectionThunk, initImageListThunk } from "../../redux/collection/thunk";
import UnloadImages from "./UnloadImages";
import styles from "./unload.module.css"
import EditUnloadDataForm from "./EditUnloadDataForm";
import { isGovernemnt } from "../../util/form/form";

function Unload() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const [unloadSignatureDialog, setUnloadSignatureDialog] =
        useState<boolean>(false);
    const [unloadunloadPhotoDialog, setUnloadunloadPhotoDialog] =
        useState<boolean>(false);
    const [editUnloadDialog,setEditUnloadDialog] = useState<boolean>(false)
    const [signature_image, setSignatureImage] = useState<string>("");
    const [remark, setRemark] = useState<string>("");
    const { unloadCollectionInfo ,selectedUnloadCollectionInfo} = useSelector(
        (state: IRootState) => state.collectionState
    );
    const [selectedUnloadId, setSelectedUnloadId] = useState<number>(0);
    const [selectedUnloadDetailId, setSelectedUnloadDetailId] =
        useState<number>(0);
    const [selectedUnloadDate, setSelectedUnloadDate] = useState<
        Date | Moment | string
    >("");
    const { user } = useSelector((state: IRootState) => state.userAuth);
    const isGovernmentRole = isGovernemnt(user?.token?.role_id as number);

    function handleClickImage(unloadCollectionInfo: UnloadCollectionInfo) {
        setSignatureImage(unloadCollectionInfo.signature_image);
        setRemark(unloadCollectionInfo.remark);
        setUnloadSignatureDialog(true);
    }

    async function handleClickUnloadImage(
        unloadCollectionInfo: UnloadCollectionInfo
    ) {
        dispatch(OpenLoadingBarThunk(true));
        const result = await axiosGet(
            `/api/unload/image/${unloadCollectionInfo.unload_id}`
        );
        if (result.data.success) {
            dispatch(OpenLoadingBarThunk(false));
            dispatch(initImageListThunk(result.data.unloadImageList));
            setUnloadunloadPhotoDialog(true);
            setSelectedUnloadId(unloadCollectionInfo.unload_id);
            setSelectedUnloadDetailId(unloadCollectionInfo.unload_detail_id);
            setSelectedUnloadDate(unloadCollectionInfo.unload_date);
        } else {
            dispatch(OpenLoadingBarThunk(false));
            dispatch(OpenSnackBarWithResultFail("未能取得卸貨相片"));
            return;
        }
    }

    function handleCloseDialog() {
        setUnloadSignatureDialog(false);
        setUnloadunloadPhotoDialog(false);
        setEditUnloadDialog(false)
    }

    function handleClickEdit (unloadCollectionInfo: UnloadCollectionInfo){
        setEditUnloadDialog(true)
        dispatch(InitSelectedUnloadCollectionThunk(unloadCollectionInfo))
    }

    async function handleSubmitEditData(){
        const result = await axiosPutWithJson(`/api/unload/${selectedUnloadCollectionInfo?.unload_id}/detail/${selectedUnloadCollectionInfo?.unload_detail_id}`,selectedUnloadCollectionInfo)
        if (result.data.success){
            dispatch(OpenSnackBarWithResultSuccess(result.data.message))
            dispatch(ChangeUnloadDataListThunk(unloadCollectionInfo,selectedUnloadCollectionInfo!))
            setEditUnloadDialog(false)
        }else{
            dispatch(OpenSnackBarWithResultFail('你未能更改卸貨資料'))
        }
    
    }

    const columns: GridColDef[] = [
        {
            field: "unload_id",
            headerName: "卸貨號碼",
            flex: 1,
        },
        {
            field: "unload_date",
            headerName: "卸貨日期",
            flex: 2,
            renderCell: (data) => (
                <div>
                    {data.value
                        ? moment.utc(data.value).format("YYYY-MM-DD HH:mm:ss")
                        : null}
                </div>
            ),
        },
        { field: "depot_cn", headerName: "卸貨地點", flex: 1 },
        { field: "paper_weight", headerName: "磅飛重量（紙）", flex: 2 },
        { field: "metal_weight", headerName: "磅飛重量（金屬）", flex: 2 },
        { field: "plastic_weight", headerName: "磅飛重量（塑膠）", flex: 2 },
        { field: "total_weight", headerName: "總重量", flex: 1 },
        {
            field: "action2",
            headerName: "卸貨相片",
            flex: 1,
            renderCell: (data) => {
                return (
                    <Button
                        variant="contained"
                        onClick={() => handleClickUnloadImage(data.row)}
                    >
                        <EditNote />
                        <Grid>卸貨</Grid>
                    </Button>
                );
            },
        },
        {
            field: "action",
            headerName: "學校簽名",
            flex: 1,

            renderCell: (data) => {
                return data.row.depot_id === 2 ? (
                    <></>
                ) : (
                    <Button
                        variant="contained"
                        onClick={() => handleClickImage(data.row)}
                    >
                        <EditNote />
                        <Grid>簽名</Grid>
                    </Button>
                );
            },
        },

        {
            field: "edit",
            headerName: "修改紀錄",
            flex: 2,
            renderCell: (data) => (
                <div>
                        <Button
                            variant="contained"
                            className={styles.editBtn}
                            onClick={()=>handleClickEdit(data.row)}
                        >
                            <EditNote />
                            <Grid>更改</Grid>
                        </Button>       
                </div>
            ),
        },
    ];


    return (
        <div>
            <Grid>本車線共卸貨 {unloadCollectionInfo.length} 次</Grid>

            <div style={{ height: "100%", width: "100%" }}>
                <DataGrid
                    rows={unloadCollectionInfo || []}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 30 },
                        },
                    }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    getRowId={(row) => row.unload_id}
                    columnVisibilityModel={
                        isGovernmentRole
                        ? {
                            unload_id:false,
                            edit:false,
                          }: 

                   {}
                    }
                />
            </div>

            <FormDialog
                title="學校簽名"
                open={unloadSignatureDialog}
                handleClose={handleCloseDialog}
                size="lg"
            >
                {remark ? (
                    <div>
                        <div>沒有相片原因：</div>
                        <div>{remark}</div>
                    </div>
                ) : (
                    <img
                        src={`${process.env.REACT_APP_S3}${signature_image}`}
                    />
                )}
            </FormDialog>

            <FormDialog
                title="卸貨相片"
                open={unloadunloadPhotoDialog}
                handleClose={handleCloseDialog}
                size="lg"
            >
                <UnloadImages
                    selectedUnloadId={selectedUnloadId}
                    selectedUnloadDetailId={selectedUnloadDetailId}
                    selectedUnloadDate={selectedUnloadDate}
                />
            </FormDialog>


            <FormDialog
                title="更改卸貨資料"
                open={editUnloadDialog}
                handleClose={handleCloseDialog}
                size="lg"
                handleSubmit={handleSubmitEditData}
            >
                <EditUnloadDataForm/>
            </FormDialog>
        </div>
    );
}



export default Unload;
